import{i as n}from"./chunk-AW3GRB7I.js";import{a as o}from"./chunk-O4CMJPNZ.js";import{m as r}from"./chunk-HBP5N4FR.js";r();var p=e=>{let t=e!=null?e:n(o.getState());return t.endsWith("/")?t.slice(0,-1):t};export{p as a};
//# sourceMappingURL=chunk-WZX4YCAI.js.map
